<template>
	<header class="c-header">
		<div class="c-header__inner">
			<h1 class="c-header__title">
				<a href="/">
					<img src="/assets/img/svg/logo.svg" alt="CoDogue">
				</a>
			</h1>


			<button class="c-header__show-menu" @click="showMenu = !showMenu" :class="{'-open': showMenu}">
				<c-icon :name="'chevron-down'"></c-icon>
			</button>
		</div>
		<transition name="c-header-menu">
			<nav class="c-header-menu" v-show="showMenu">
				<ul class="c-header-menu__list">
					<li v-for="app in apps"><a :href="app.path">{{app.name}}</a></li>
				</ul>
			</nav>
		</transition>
	</header>
</template>

<script>

import apps from "../json/apps";
import cIcon from "./icon.vue";

export default {
	name: "c-header",
	components: {
		cIcon
	},
	data(){
		return {
			apps: apps,
			showMenu: false
		}
	}
}

</script>


// WEBPACK FOOTER //
// header.vue?7272cd21